export default "__VITE_PUBLIC_ASSET__16a7572a__"